import React from 'react'

const customInterfaceFunction = () => (

    localStorage.getItem('lang') + "-" + localStorage.getItem('lang').toUpperCase()
)

export default customInterfaceFunction